import { ProgressIndicator } from '@eventbrite/eds-progress-indicator';
import React from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../utils/rebrand';
import defaultStyles from './FullPageLoadingLayer.module.scss';
import rebrandStyles from './FullPageLoadingLayer.rebranding.module.scss';

export type FullPageLoadingLayerProps = {
    isShown?: boolean;
    children?: React.ReactElement;
    isAppRebrandActive?: boolean;
};

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export const FullPageLoadingLayer: React.FC<FullPageLoadingLayerProps> = ({
    isShown = false,
    children,
    isAppRebrandActive = false,
}) => {
    if (!isShown) {
        return null;
    }

    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];

    const progressIndicatorStyle = isAppRebrandActive ? 'dark' : 'gradient';

    return (
        <div className={styles.fullPageLoadingLayer} aria-live="polite">
            <div data-spec="spinner">
                <ProgressIndicator
                    style={progressIndicatorStyle}
                    isAppRebrandActive={isAppRebrandActive}
                />
            </div>
            {children}
        </div>
    );
};
